<template>
    <van-popup class="web-report-popup" :value="showWebReport" @click-overlay="clickClose">
        <div class="web-report-pop-close" @click="clickClose"><i class="iconfont icon-guanbi"></i></div>
        <!-- 1. 标题部分 -->
        <div class="web-report-pop-title">
            <div class="web-report-pop-title1">{{reportTitle}}</div>
            <div class="web-report-pop-title-sub">{{showSelectList || selectedReportType == 4 ? '请选择举报理由' : '举报说明'}}</div>
        </div>
        <!-- 2. 选项部分 -->
        <div v-if="showSelectList" class="famous-comment-report-list">
            <div v-for="reportData in reportList" v-bind:key="'report'+reportData.type" class="famous-crli-item" @click="clickSelectReport(reportData)">
                <span>{{reportData.text}}</span><i class="iconfont icon-xiangyou"></i>
            </div>
        </div>
        <!-- 3. 举报输入框 -->
        <div v-if="!showSelectList && selectedReportType != 4" class="famous-comment-report-textarea-box">
            <textarea class="famous-comment-report-textarea" placeholder="举报详细说明(选填)" name="" id="ReportTextarea" cols="30" rows="10" maxlength="150" v-model="textValue"></textarea>
        </div>
        <div v-if="!showSelectList && selectedReportType == 4" class="famous-comment-report-textarea-box">
            <div v-for="harmData in harmList" v-bind:key="'harm'+harmData.type" class="famous-crli-item" @click="clickSelectHarm(harmData)">
                <span>{{harmData.text}}</span><i class="iconfont " v-bind:class="{'icon-unselected': selectedHarmType != harmData.type, 'icon-selected' : selectedHarmType == harmData.type}"></i>
            </div>
        </div>
        <!-- 4. 按钮部分 -->
        <!-- <div v-if="showSelectList" class="famous-comment-report-button">
            <button class="famous-crb-report-b famous-crb-report-b-long" @click="clickReportFirst">举报</button>
        </div> -->
        <div v-if="!showSelectList" class="famous-comment-report-button">
            <button class="famous-crb-report-d" @click="resetData">返回</button>
            <button class="famous-crb-report-b" @click="clickReportSecond">举报</button>
        </div>
        <!-- 5. 提示信息部分 -->
        <div v-if="!showSelectList && reportMsg != ''" class="web-report-pop-sub-content">
            <p>{{reportMsg}}</p>
        </div>
    </van-popup>
</template>

<script>
export default {
    name: 'WebReportPop',
    computed: {
        showWebReport() {
            return this.$store.state.weblogin.showWebReport
        }
    },
    data() {
        return {
            reportTitle: '举报',
            reportList: [
                {type: 1, text: '垃圾广告信息', msg: '未经平台允许，木火通明禁止使用帐号的任何功能，发布含有产品售卖信息、牟利性外链及违规推广等信息或引导用户至第三方平台进行交易。请在举报时简述理由，感谢你与我们共同维护社区的良好氛围。'}, 
                {type: 2, text: '不实信息', msg: '为保证站内信息传播的客观真实，木火通明会持续对社会谣言类不实信息进行处理。请在举报时提供政府机构、有关机构、权威媒体发布的辟谣信息或其他佐证，木火通明将会核实处理，感谢你的支持。'}, 
                {type: 3, text: '辱骂、人身攻击等不友善行为', msg: '木火通明鼓励友善的讨论。请在举报时提供对人产生辱骂、人身攻击或冒犯的相关内容段落或其他信息。感谢你与我们共同维护木火通明的讨论氛围。'}, 
                {type: 4, text: '有害信息'}, 
                {type: 5, text: '诱导赞同、关注等行为', msg: '木火通明禁止通过各种方式比如利益诱导（赞同、反对、分享行为后对用户有奖励）、威胁逼迫等形式干预用户在站内的赞同、关注等，影响内容在站内正常流通。请在举报时简述理由，感谢你与我们共同维护社区氛围。'}, 
            ],
            harmList: [
                {type: 1, text: '政治敏感'},
                {type: 2, text: '色情低俗'},
                {type: 3, text: '有人意图自杀或自残'},
                {type: 4, text: '违法违规'},
            ],
            selectedHarmType: 1,
            showSelectList: true,
            selectedReportType: 0,
            reportMsg: '',
            textValue: ''
        }
    },
    mounted() {
        this.resetData();
    },
    methods: {
        clickClose() {
            this.$store.state.weblogin.showWebReport = false;
        },
        clickSelectReport(reportData) {
            this.showSelectList = false;
            this.selectedReportType = reportData.type;
            this.reportTitle = reportData.text;
            this.reportMsg = reportData.msg;
        },
        clickSelectHarm(harmData) {
            this.selectedHarmType = harmData.type;
            this.textValue = harmData.text;
        },
        clickReportFirst() {},
        resetData() {
            this.showSelectList = true;
            this.reportTitle = '举报';
            this.selectedHarmType = 1;
            this.selectedReportType = 0;
        },
        clickReportSecond() {
            var me = this,
                baikeId = this.$store.state.famouspedia.curPediaBaziId;
            console.log('clickReport-----', this.textValue, this.selectedReportType, baikeId)
            this.$store.dispatch('famouspediacomment/reportComment', {
                bid: baikeId,
                msg: this.textValue,
                type: this.selectedReportType,
                cb: function() {
                    me.showSelectList = true; 
                    me.$store.state.weblogin.showWebReport = false;     
                }
            });
        }
    }
}
</script>